import React from 'react'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import Add from '@material-ui/icons/Add'
import Remove from '@material-ui/icons/Remove'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/QuantitySelector.
// A quantity field with plus/minus buttons. The input is read-only;
// value changes flow only through the buttons (matching the original).
const useStyles = makeStyles(
  theme => ({
    root: {
      backgroundColor: theme.palette.divider,
      border: 'none',
      width: '110px',
      padding: 0,
    },
    icon: {
      fontSize: '1.3125rem',
      position: 'relative',
    },
    button: {
      height: '36px',
      width: '36px',
      padding: 0,
    },
    subtract: {
      marginRight: theme.spacing(-4.5),
    },
    add: {
      marginLeft: theme.spacing(-4.5),
    },
    input: {
      width: 100,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.grey[200],
      textAlign: 'center',
      padding: theme.spacing(1, 0, 1, 0),
      border: 'none',
      fontSize: theme.spacing(2),
      outline: 'none',
      '&::before': {
        display: 'none',
      },
    },
  }),
  { name: 'RSFQuantitySelector' },
)

export default function QuantitySelector({
  name = 'quantity',
  classes,
  addIcon,
  addButtonProps = {},
  subtractIcon,
  subtractButtonProps = {},
  value,
  minValue = 1,
  maxValue = 100,
  onChange = () => {},
  inputProps = {},
  ariaLabel = 'quantity',
}) {
  classes = useStyles({ classes })
  const { quantitySelector, icon, button, ...inputClasses } = classes
  if (!value) value = 1

  function handleChange(next) {
    if (next >= minValue && next <= maxValue) {
      onChange(next)
    }
  }

  return (
    <>
      <IconButton
        size="small"
        classes={{ root: button }}
        className={classes.subtract}
        onClick={() => handleChange(value - 1)}
        aria-label={`add one ${ariaLabel}`}
        {...subtractButtonProps}
      >
        {subtractIcon || <Remove classes={{ root: icon }} />}
      </IconButton>
      <input
        onChange={handleChange}
        value={value}
        name={name}
        aria-label={ariaLabel}
        className={clsx([classes.input, inputClasses])}
        {...inputProps}
        readOnly
      />
      <IconButton
        size="small"
        classes={{ root: button }}
        className={classes.add}
        onClick={() => handleChange(value + 1)}
        aria-label={`subtract one ${ariaLabel}`}
        {...addButtonProps}
      >
        {addIcon || <Add classes={{ root: icon }} />}
      </IconButton>
    </>
  )
}
